module.exports = __webpack_public_path__ + "static/media/ic_logo_sp.8ce8b248.svg";